<script>
    // export let label = null;
    // export let value= '';
    // export let edit = false;
    import { setContext } from 'svelte'
    import { writable } from 'svelte/store'
    import { InputText, Typography } from '.'
    let startIndex = -1
    setContext('count', writable(-1))
    setContext('SetIndex', {
        index: () => {
            startIndex += 1
            return startIndex
        },
    })
    const types = {
        text: InputText,
    }
</script>

<span class="item">
    <slot />
</span>

<style>
    :root {
        --min-height: 72px;
        --height: auto;
    }
    span {
        min-height: var(--min-height);
        height: (--height);
        position: relative;
        width: 100%;
        font-family: Roboto;
        display: flex;
    }
    span.item {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px var(--color-grey-300) solid;
    }
</style>
